<template>
  <div id="footer" >
    <div class="container">
      <div class="logoAcontact row">
        <div class="left-cont col-xs-12 col-sm-5 col-md-5">
          <div class="logotype">
            <img src="@/assets/image/logo2.png">
          </div>
          <div class="emailcontact">
            <img src="@/assets/image/email.png">
            <span>E-mail:contact@sutorcn.com</span>
          </div>
        </div>
        <div class="right-cont col-xs-12 col-sm-7 col-md-7">
          <ul class="pagelink">
            <li>
              <router-link to="/" tag="a">集团首页</router-link>
            </li>
            <li>
              <router-link to="/productserve" tag="a">产品与服务</router-link>
            </li>
            <li>
              <router-link to="/studycenter" tag="a">研发中心</router-link>
            </li>
            <li>
              <router-link to="/contactus" tag="a">联系我们</router-link>
            </li>
          </ul>
<!--          <ul class="morecontact">
            <li>
              <a href="#">联系方式：</a>
            </li>
            <li>
              <a href="#">联系方式：</a>
            </li>
            <li>
              <a href="#">联系方式：</a>
            </li>
          </ul>-->
        </div>

      </div>
<!--      <p>Copyright © 2021 常熟华冶薄板有限公司 版权所有 苏ICP备13019471</p>-->
    </div>
<!--    <div class="logo">-->
<!--      <img src="@/assets/img/logo_white.png" alt="logo图">-->
<!--    </div>-->
<!--    <p class="title">公司企业网站模板</p>-->
<!--    <p class="address_tel_fax">-->
<!--      <span>地址：公司地址公司地址公司地址公司地址</span>-->
<!--      <span>Tel：888-888-888</span>-->
<!--      <span>Fax：8888-88888888</span>-->
<!--    </p>-->
<!--    <p class="email_wx">-->
<!--      <span>邮箱：liyunkun_11@163.com</span>-->
<!--      <span>公司微信号：ilyk_gg</span>-->
<!--    </p>-->
<!--    <p class="copy">Copyright &copy; 2018 - 2019 公司名称公司名称</p>-->
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  font-family: 微软雅黑;
  width: 100%;
  height: 100%;
  color: #fff;
  background: #014594;
  overflow: hidden;
  text-align: center;
  padding-bottom: 40px;
}
.logoAcontact{
  padding: 100px 0px;
}
.logoAcontact .left-cont > .logotype{
  margin-bottom: 50px;
}
.logoAcontact .left-cont > .emailcontact{
  text-align: left;
}
.logoAcontact .left-cont > .emailcontact > img{
  display: inline-block;
  margin-right: 20px;
}
.logoAcontact .left-cont > .emailcontact > span{
  vertical-align: middle;
  letter-spacing:1px;
}
.logoAcontact .right-cont .pagelink{
  margin-top: 30px;
  display: flex;
  justify-content: space-around;
}
.logoAcontact .right-cont .pagelink a{
  text-decoration: none;
  color: white;
  text-decoration:underline;
}
.logoAcontact .right-cont .morecontact{
  margin-top: 50px;
  display: flex;
  justify-content: space-around;
}
.logoAcontact .right-cont .morecontact li{
  width: 202px;
  height: 51px;
  line-height: 51px;
  text-align: center;
  background: #093160;
  margin-right: 10px;
}
.logoAcontact .right-cont .morecontact li > a{
  text-decoration: none;
  color: white;
}
/*.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}*/
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue